
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#v-shield_svg__clip0_777_1643)"}},[_c('path',{attrs:{"d":"M14.563 3.125c.562.25.937.781.937 1.375 0 8.125-5.969 12-7.531 12C6.406 16.5.5 12.562.5 4.5c0-.594.344-1.125.906-1.375l6-2.5a1.82 1.82 0 011.157 0l6 2.5zm-.094 1.406c0-.093 0-.343-.281-.468l-6-2.5C8.124 1.53 8.062 1.5 8 1.5c-.094 0-.156.031-.219.063l-6 2.5c-.187.062-.281.25-.281.437 0 7.031 5.156 11 6.5 11 1.281 0 6.469-3.938 6.469-10.969zM10.5 6.188c.281 0 .5.218.5.5 0 .125-.063.25-.156.343L7.5 10.375a.47.47 0 01-.344.125.47.47 0 01-.343-.125L5.125 8.719A.6.6 0 015 8.344c0-.25.188-.5.5-.5.125 0 .25.062.344.156l1.312 1.313 2.969-3c.094-.094.219-.125.375-.125z","fill":"#478FFF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"v-shield_svg__clip0_777_1643"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    